import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 bg-background-100 relative overflow-hidden">
      {/* Background product image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20product%20research%20workspace%20with%20a%20laptop%20showing%20product%20listings%20surrounded%20by%20a%20few%20folded%20garments%20and%20a%20plant%20on%20a%20light%20oak%20desk%20against%20a%20soft%20sage%20green%20wall%2C%20bright%20airy%20daylight%2C%20minimal%20editorial%20photography%20in%20fresh%20neutral%20tones&width=1600&height=900&seq=cta-bg-2026-01&orientation=landscape&nocache=true"
          alt="Product showcase background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/70 backdrop-blur-[2px]" />
      </div>

      <div className="relative z-10 container-main">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-300 uppercase tracking-wider mb-3">
            <i className="ri-sparkling-line" />
            {t('common.independent')}
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('cta.ready_title')}
          </h2>
          <p className="text-sm md:text-base text-white/75 mb-8 leading-relaxed">
            {t('cta.ready_desc')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-white font-medium text-sm whitespace-nowrap transition-all hover:bg-primary-600 hover:scale-[1.02] active:scale-[0.98]"
            >
              {t('cta.visit_main')}
              <i className="ri-external-link-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white/10 backdrop-blur-sm text-white font-medium text-sm whitespace-nowrap border border-white/25 transition-all hover:bg-white/20"
            >
              {t('cta.buy_now')}
              <i className="ri-shopping-bag-line" />
            </a>
          </div>

          <p className="text-xs text-white/50 mt-6">
            Independent resource • All links open in a new tab
          </p>
        </div>
      </div>
    </section>
  );
}